module.exports = __webpack_public_path__ + "img/logo_fullfreela_white_old.f562ecd0.svg";